import {IProduct} from "../../interfaces/IProduct";
import {Table} from "react-bootstrap";
import Link from "next/link";
import styled from "styled-components";
import {getTheme} from "../../shared/themeUtils";
import {useMessages} from "../../hooks/useMessages";

const Contain = styled.div`
    table {
        margin-bottom: 0;
    }

    tr {
        &:last-of-type {
            border-color: transparent;
        }
    }

    td {
        font-size: ${getTheme("fontSizes.small")};
    }

    .label {
        font-weight: bold;
    }

    .link {
        color: ${getTheme("colors.link")};
    }
`

const ProductRelatedLinks = ({product}: { product: IProduct }) => {
  const messagesQuery = useMessages()

  return (
    <Contain>
      <Table>
        <tbody>
        {messagesQuery.data &&
          <tr>
            <td className={"label"}>
              {messagesQuery.data.messages["product"]} #
            </td>
            <td>
              {product.productID}
            </td>
          </tr>
        }
        {product && product.productDetails && product.productDetails.map(entry => (
          <tr key={entry.link.href}>
            <td className={"label"}>
              {entry.label}
            </td>
            <td className={"link"}>
              <Link href={`/${entry.link.href}`}>{entry.link.text}</Link>
            </td>
          </tr>
        ))}
        </tbody>
      </Table>
    </Contain>
  )
}

export default ProductRelatedLinks